"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setEventTransfer = exports.getEventTransfer = exports.SLATE_TRANSFER_TYPES = void 0;
var Base64Serialiser_1 = __importDefault(require("./Base64Serialiser"));
exports.SLATE_TRANSFER_TYPES = {
    FRAGMENT: "application/x-slate-fragment",
    HTML: "text/html",
    NODE: "application/x-slate-node",
    RICH: "text/rtf",
    TEXT: "text/plain",
};
function setEventTransfer(transfer, type, content) {
    var mime = exports.SLATE_TRANSFER_TYPES[type.toUpperCase()];
    if (!mime) {
        throw new Error("Cannot set unknown transfer type \"".concat(mime, "\"."));
    }
    try {
        transfer.setData(mime, content);
        transfer.setData("text", transfer.getData("text"));
    }
    catch (err) {
        var prefix = "SLATE-DATA-EMBED::";
        var text = transfer.getData(TEXT);
        var obj = {};
        if (text.substring(0, prefix.length) === prefix) {
            try {
                obj = JSON.parse(text.substring(prefix.length));
            }
            catch (e) {
                throw new Error("Failed to parse Slate data from `DataTransfer` object.");
            }
        }
        else {
            obj[TEXT] = text;
        }
        obj[mime] = content;
        var string = "".concat(prefix).concat(JSON.stringify(obj));
        transfer.setData(TEXT, string);
    }
}
exports.setEventTransfer = setEventTransfer;
var FRAGMENT = exports.SLATE_TRANSFER_TYPES.FRAGMENT, HTML = exports.SLATE_TRANSFER_TYPES.HTML, NODE = exports.SLATE_TRANSFER_TYPES.NODE, RICH = exports.SLATE_TRANSFER_TYPES.RICH, TEXT = exports.SLATE_TRANSFER_TYPES.TEXT;
var FRAGMENT_MATCHER = / data-slate-fragment="([^\s"]+)"/;
function getEventTransfer(transfer) {
    var fragment = getType(transfer, FRAGMENT);
    var node = getType(transfer, NODE);
    var html = getType(transfer, HTML);
    var rich = getType(transfer, RICH);
    var text = getType(transfer, TEXT);
    var files;
    var slateDataAttribute = "data-slate-fragment";
    if (!fragment && html && ~html.indexOf(" ".concat(slateDataAttribute, "=\""))) {
        var matches = FRAGMENT_MATCHER.exec(html);
        var _a = __read(matches, 2), encoded = _a[1];
        if (encoded)
            fragment = encoded;
    }
    if (text) {
        var embeddedTypes = getEmbeddedTypes(text);
        if (embeddedTypes[FRAGMENT])
            fragment = embeddedTypes[FRAGMENT];
        if (embeddedTypes[NODE])
            node = embeddedTypes[NODE];
        if (embeddedTypes[TEXT])
            text = embeddedTypes[TEXT];
    }
    if (fragment) {
        fragment = Base64Serialiser_1.default.deserializeNode(fragment);
    }
    if (node) {
        node = Base64Serialiser_1.default.deserializeNode(node);
    }
    try {
        if (transfer.items && transfer.items.length) {
            files = Array.from(transfer.items)
                .map(function (item) { return (item.kind == "file" ? item.getAsFile() : null); })
                .filter(function (exists) { return exists; });
        }
        else if (transfer.files && transfer.files.length) {
            files = Array.from(transfer.files);
        }
    }
    catch (err) {
        if (transfer.files && transfer.files.length) {
            files = Array.from(transfer.files);
        }
    }
    var data = { files: files, fragment: fragment, html: html, node: node, rich: rich, text: text, type: "" };
    data.type = getTransferType(data);
    return data;
}
exports.getEventTransfer = getEventTransfer;
function getEmbeddedTypes(text) {
    var prefix = "SLATE-DATA-EMBED::";
    if (text.substring(0, prefix.length) != prefix) {
        return { TEXT: text };
    }
    try {
        return JSON.parse(text.substring(prefix.length));
    }
    catch (err) {
        throw new Error("Unable to parse custom Slate drag event data.");
    }
}
function getTransferType(data) {
    if (data.fragment)
        return "fragment";
    if (data.node)
        return "node";
    if (data.rich && data.html)
        return "html";
    if (data.rich && data.text)
        return "text";
    if (data.files && data.files.length)
        return "files";
    if (data.html)
        return "html";
    if (data.text)
        return "text";
    return "unknown";
}
function getType(transfer, type) {
    if (!transfer.types || !transfer.types.length) {
        return type == TEXT ? transfer.getData("Text") || null : null;
    }
    var types = Array.from(transfer.types);
    return types.indexOf(type) !== -1 ? transfer.getData(type) || null : null;
}
